import { render, staticRenderFns } from "./TenderTaxes.vue?vue&type=template&id=7a74a47d&"
import script from "./TenderTaxes.vue?vue&type=script&lang=js&"
export * from "./TenderTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports